import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { TextField, Autocomplete, Button, CircularProgress } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import { toast } from "react-toastify";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { commonFileUpload, getAllNofificationForDashboard } from "src/thunks/dashboard";
import { addNewDepotPersonal, EditDepotPersonal } from "src/thunks/depotUsers";
import { addProjectManagerFormValidationSchema } from "src/helpers/yup_schema";
import toastMessages from "src/constant/toastMessages.json";
import { GetError } from "src/constant";
import { getAllClientProject } from "src/thunks/clientProjects";
import { Loader } from "src/components/loader";

export const AddProjectManagerForm = ({ setOpen, selectedData, isEditTextShown, setIsEditTextShown, getUpdateData, handleViewRecordButtonClick }) => {

  console.log("selected data", selectedData)
  /** redux store useDispatch & useSelector ------------------------------ **/
  const { addNewDepotPersonelLoading } = useSelector((state) => state.depotUsers);
  const clientProjects = useSelector((state) => state?.clientProjects?.clientProject);
  const dispatch = useDispatch();

  console.log("client project array", clientProjects)

  /** hooks useState ----------------------------------------------------- **/
  const [isLoading, setIsLoading] = useState(false);
  const [allItem, setallItem] = useState([]);
  console.log("all item", allItem)
  const [projectDropdownValue, setProjectDropdownValue] = useState({ name: "" });
  const [projectDropdownValueError, setProjectDropdownValueError] = useState("");
  const [profilePic, setProfilePic] = useState("https://img.freepik.com/free-icon/user_318-563642.jpg");
  const [ProjectManagerStateData, _ProjectManagerStateData] = useState({});
  const [projectArray, setProjectArray] = useState([]);
  const [clientError, setClientError] = useState("")

  console.log("pm state data is", ProjectManagerStateData)


  /** Variable declarations ----------------------------------------------------- **/
  const autocompleteRef = useRef(null);

  /** react hook form declaration ------------------------------ **/
  const {
    register,
    handleSubmit,
    control,
    clearErrors,
    formState: { errors },
    reset,
    watch
  } = useForm({
    resolver: yupResolver(addProjectManagerFormValidationSchema),
    defaultValues: {
      client: []
    }
  });

  console.log("valueuueue", handleSubmit())

  /** hooks useEffect----------------------------------------------------- **/
  useEffect(() => {
    setEditDataFun();
    return () => {
      setIsEditTextShown(false);
    };
  }, [isEditTextShown]);


  /** handler functions--------------------------------------------------- **/

  /** Function to retrieve all clients with projects. ------------------- **/
  const getAllClientsData = async () => {
    setIsLoading(true)
    try {
      let res = await dispatch(getAllClientProject()).unwrap();
      setIsLoading(false)
      return res;
    } catch (err) {
      setIsLoading(false)
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    }
  };

  /** Function to reset the data in the form, which is required for editing --------------------- **/
  const setEditDataFun = async () => {
    const clientsData = await getAllClientsData();
    if (Object.keys(selectedData).length > 0) {
      let clientData = _.find(clientProjects, (d) => d.id === parseInt(selectedData?.projects[0]?.clientId))
      const getAllClientIds = selectedData?.projects?.map((item) => item?.clientId);
      const filteredClients = clientsData?.filter(client => getAllClientIds?.includes(client?.id));
      reset({
        firstName: selectedData?.firstName || "",
        middleName: selectedData?.middleName || "",
        lastName: selectedData?.lastName || "",
        email: selectedData?.email,
        phone: selectedData?.phoneNumber,
        client: filteredClients
      });
      setProfilePic(selectedData?.profileUrl || '');
    }
  }

  const allOnChangeHandler = (title, value) => {
    _ProjectManagerStateData({ ...ProjectManagerStateData, [title]: value });
  };

  /** Function to add new project manager or edit an existing project manager. ----------------- **/
  const onAddProjectManagerSubmitHandler = async (data) => {
    let newData = {
      clientName: ProjectManagerStateData?.clientNames || "",
      firstName: data?.firstName || "",
      middleName: data?.middleName || "",
      lastName: data?.lastName || "",
      email: data?.email || "",
      userName: data?.email || "",
      phoneNumber: (data?.phone).toString() || "",
      role: "ProjectManager",
      profileUrl: profilePic,
      projects: _.map(allItem, (d) => ({
        id: d?.id,
        name: d?.name
      })),
    };
    let editNewData = {
      clientName: ProjectManagerStateData?.clientNames || "",
      firstName: data?.firstName || "",
      middleName: data?.middleName || "",
      lastName: data?.lastName || "",
      email: data?.email || "",
      userName: data?.email || "",
      phoneNumber: (data?.phone).toString() || "",
      role: "ProjectManager",
      profileUrl: profilePic,
      projects: _.map(selectedData?.projects, (d) => ({
        id: d?.id,
        name: d?.name
      })),
    };
    try {
      if (Object.keys(selectedData).length > 0) {
        let ModelData = {
          data: editNewData,
          id: selectedData?.id,
          "isParentResourceUpdated": true,
          "isProjectManager": true
        };
        let result = await dispatch(EditDepotPersonal(ModelData)).unwrap();
        if (result) {
          setTimeout(() => {
            dispatch(getAllNofificationForDashboard(1, 20));
          }, 2000);
          await handleViewRecordButtonClick();
          setOpen();
          toast.success(toastMessages.projectManagerEdited);
        }
      } else {
        let result = await dispatch(addNewDepotPersonal({ ...newData, "isProjectManager": true })).unwrap();
        if (result) {
          setTimeout(() => {
            dispatch(getAllNofificationForDashboard(1, 20));
          }, 2000);
          getUpdateData();
          setOpen();
          toast.success(toastMessages.projectManagerAdded);
        }
      }
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    }

  };

  /** Function to upload a photo and save it into the state ----------------------- **/
  const photoUpload = (e) => {
    setIsLoading(true);
    e.preventDefault();
    const reader = new FileReader();
    const file = e.target.files[0];
    if (file) {
      const fileType = file.type;
      if (!["image/png", "image/jpg", "image/jpeg", "image/jfif", "image/PNG", "image/JPG", "image/JPEG"].includes(fileType)) {
        setIsLoading(false);
        toast.error("Please select valid image format");
      } else {
        const formData = new FormData();
        formData.append("files", file);
        reader.onloadend = async () => {
          let res = await dispatch(commonFileUpload(formData));
          setIsLoading(false);
          if (res) {
            const urlData = res.payload[0].url;
            setProfilePic(urlData);
          }
        };
        reader.readAsDataURL(file);
      }
    }
  };

  /** Function to remove the added project from the list -------------------- **/
  const handleRemoveItemIconClickFromTable = (item) => {
    const result = allItem.filter((data) => data.id !== item.id);
    setallItem([...result]);
    setProjectArray([...projectArray, { ...item }]);
  };

  /** Function to handle the cancel button click ------------------- **/
  const handleCancelButtonClick = () => {
    setOpen(false);
    reset();
    setProfilePic(
      "https://www.seekpng.com/png/detail/245-2454602_tanni-chand-default-user-image-png.png"
    );
  };

  /** Function executes when a project is selected from the dropdown ----------------------- **/
  const handleProjectNameChange = (event, values) => {
    clearErrors("project");
    setProjectDropdownValue(values);
    setProjectDropdownValueError("");
  };

  /** Function executes when a client is selected and sets its projects in the state ----------------- **/
  const handleClientNameChange = (values) => {
    allOnChangeHandler("clientNames", values?.map((item) => item.name).join(', '));
    const getAllClientIds = values?.map((item) => item?.id);
    const filteredClients = clientProjects?.filter(client => getAllClientIds?.includes(client?.id));
    const allClientsProjects = values?.flatMap(item => item?.projects || []);
    const filteredProjectsArray = _.differenceBy(allClientsProjects, allItem, 'id');
    setProjectArray(filteredProjectsArray);
    const filteredArray = allClientsProjects.filter(obj1 =>
      allItem.some(obj2 => obj2.id === obj1.id)
    );
    setallItem([...filteredArray]);
  };

  /** Function executes when adding a new project -------------------- **/
  const handleAddProjectClick = () => {
    if (projectDropdownValue?.name == "") {
      setProjectDropdownValueError("please add project here");
    } else {
      setProjectDropdownValueError("");
      setallItem([...allItem, { ...projectDropdownValue }]);
      setProjectDropdownValue({ name: "" });
      autocompleteRef.current.value = null;
      setProjectArray(
        projectArray.filter((option) => option.id !== projectDropdownValue.id)
      );
    }
  };

  /** Function to clear the selected project from the dropdown --------------------- **/
  const handleClearProjectClick = () => {
    autocompleteRef.current.value = null;
    setProjectDropdownValue({ name: "" });
    setProjectDropdownValueError("");
  };

  if (isLoading) {
    return <Loader />
  }

  return (
    <>
      <div>
        <div className="depot-form-header-style">
          {isEditTextShown ? "EDIT PROJECT MANAGER" : "ADD PROJECT MANAGER"}
        </div>
        <div style={{ marginTop: 30 }}>
          <form
            className="add-depotpersonal-form-mainclass"
            style={{ paddingLeft: 100, paddingRight: 100 }}
            onSubmit={handleSubmit(onAddProjectManagerSubmitHandler)}
          >
            <div className="row" style={{ height: 75 }}>

              <Controller
                name="client"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <Autocomplete
                    freeSolo
                    value={value}
                    readOnly={isEditTextShown ? true : false}
                    multiple
                    id="tags-standard"
                    options={_.orderBy(clientProjects, ['name'], ['asc'])}
                    getOptionLabel={(item) => item.name ? item.name : "" || ""}
                    isOptionEqualToValue={(option, value) => option.name === value.name}
                    filterSelectedOptions
                    onChange={(e, data) => {
                      onChange(data)
                      handleClientNameChange(data)
                    }
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        label="CLIENT"
                        placeholder={isEditTextShown ? "" : "Add Client"}
                        error={!!errors.client}
                        helperText={errors.client ? errors.client.message : ''}
                      />
                    )}
                  />
                )}
              />
            </div>

            <div className="mt-2">
              <div className="profileUpload">
                <img
                  className="file-input-upload profile-img"
                  src={profilePic}
                />
                <input
                  className="file-input upload"
                  type="file"
                  accept='.png, .jpg, .jpeg, .PNG, .JPG, .JPEG'
                  onChange={(e) => photoUpload(e)}
                />
                <span className="text-upload-photo">UPLOAD PHOTO</span>
              </div>
            </div>

            <div className="loader-overlay" style={{ display: isLoading ? 'flex' : 'none' }}>
              <CircularProgress />
            </div>

            <div className="row mt-4">
              <div className="col-md-4">
                <Controller
                  name="firstName"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      {...field}
                      className="depot-form-textfields-style"
                      id="standard-basic"
                      label="FIRST NAME"
                      variant="standard"
                      error={!!errors.firstName}
                      helperText={errors.firstName ? errors.firstName.message : ''}
                    />
                  )}
                />
              </div>

              <div className="col-md-4">
                <Controller
                  name="middleName"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      {...field}
                      className="depot-form-textfields-style"
                      id="standard-basic"
                      label="MIDDLE NAME(OPTIONAL)"
                      variant="standard"
                    />
                  )}
                />
              </div>

              <div className=" col-md-4">
                <Controller
                  name="lastName"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      {...field}
                      className="depot-form-textfields-style"
                      id="standard-basic"
                      label="LAST NAME"
                      variant="standard"
                      error={!!errors.lastName}
                      helperText={errors.lastName ? errors.lastName.message : ''}
                    />
                  )}
                />
              </div>
            </div>

            <span className="section-name-form-style">CONTACT INFORMATION</span>
            <div className="row mt-3">
              <div className="col-md-4">
                <Controller
                  name="email"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      {...field}
                      className="depot-form-textfields-style"
                      id="standard-basic"
                      label="EMAIL"
                      variant="standard"
                      error={!!errors.email}
                      InputProps={{
                        readOnly: isEditTextShown ? true : false
                      }}
                      helperText={errors.email ? errors.email.message : ''}
                    />
                  )}
                />
              </div>

              <div className="col-md-4">
                <Controller
                  name="phone"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      {...field}
                      className="depot-form-textfields-style"
                      id="standard-basic"
                      label="PHONE"
                      variant="standard"
                      error={!!errors.phone}
                      helperText={errors.phone ? errors.phone.message : ''}
                    />
                  )}
                />
              </div>
              <div className="form-floating col-md-4"></div>
            </div>
            {isEditTextShown ? "" :
              <span className="section-name-form-style mt-4">PROJECT</span>}
            {allItem &&
              allItem.length > 0 &&
              allItem.map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <div
                      className="row pt-1 pb-2 individual-row-for-the-projects"
                    >
                      <div className="col-md-10">{item.name}</div>
                      <div
                        className="col-md-2 d-flex justify-content-center align-items-center"
                        style={{ color: "#E94F37" }}
                        onClick={() => handleRemoveItemIconClickFromTable(item)}
                      >
                        <RemoveCircleOutlineOutlinedIcon
                          className="remove-item-icon-color"
                          style={{ cursor: "pointer" }}
                          fontSize="20"
                        />
                        <span
                          className="ms-1"
                          style={{
                            fontFamily: "Montserrat-Regular",
                            fontSize: 10,
                            cursor: "pointer",
                          }}
                        >
                          REMOVE
                        </span>
                      </div>
                    </div>
                  </React.Fragment>
                );
              })}
            {isEditTextShown ? "" :
              <div className="row mt-3" style={{ height: 70 }}>
                <div className="col-md-8">
                  <Autocomplete
                    key={{ name: projectDropdownValue?.name }}
                    ref={autocompleteRef}
                    disablePortal
                    id="combo-box-demo"
                    value={{ name: projectDropdownValue?.name }}
                    options={_.orderBy(projectArray, ['name'], ['asc'])}
                    getOptionLabel={(item) => item.name || ""}
                    onChange={handleProjectNameChange}
                    renderInput={(params) => (
                      <TextField
                        {...register("project")}
                        {...params}
                        label="PROJECT"
                        variant="standard"
                        id="standard-basic"
                        style={{ height: 42 }}
                      />
                    )}
                  />
                </div>
                <div className="col-md-4 d-flex" style={{ marginTop: 12 }}>
                  <Button
                    variant="outlined"
                    className="btn-bootstrap-submit-style"
                    style={{ color: "red", borderColor: "red" }}
                    startIcon={<CancelIcon />}
                    onClick={() => handleClearProjectClick()}
                  >
                    CLEAR
                  </Button>
                  <Button
                    variant="outlined"
                    className="btn-bootstrap-submit-style ms-3"
                    startIcon={<CheckCircleIcon />}
                    onClick={handleAddProjectClick}
                  >
                    ADD
                  </Button>
                </div>
                <div className="error-field-class">
                  {projectDropdownValueError && projectDropdownValueError}
                </div>
              </div>}

            <div
              className="d-flex flex-row justify-content-between"
              style={{ marginTop: 20, marginBottom: 20 }}
            >
              <Button
                variant="outlined"
                className="btn-bootstrap-submit-style"
                style={{ color: "red", borderColor: "red" }}
                startIcon={<CancelIcon />}
                onClick={() => handleCancelButtonClick()}
              >
                Cancel
              </Button>
              {isEditTextShown ? (
                <Button
                  variant="outlined"
                  className="btn-bootstrap-submit-style"
                  startIcon={<CheckCircleIcon />}
                  type="submit"
                >
                  Save
                </Button>
              ) : (
                <Button
                  disabled={addNewDepotPersonelLoading ? true : false}
                  variant="outlined"
                  className={`btn-bootstrap-submit-style ${addNewDepotPersonelLoading ? "fade-out" : ""}`}
                  startIcon={<CheckCircleIcon />}
                  type="submit"
                >
                  Submit
                </Button>
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
